jQuery(document).ready(function($) {

    $( ".bloc_chapeau" ).each(function( index ) {

        let bloc = this

        // Éléments
        let txt = bloc.querySelector(".txt")
        let ligne = bloc.querySelector(".ligne")
        let para = bloc.querySelector(".para")

        // États initiaux
        let txtLines
        if (txt) {
            // On sort la ligne pour que SplitText ne l'emballe pas dans une .chapeau-line
            if (ligne) ligne.remove()

            let splitTxt = new SplitText(txt, { type: "lines", linesClass: "chapeau-line" })
            txtLines = splitTxt.lines
            gsap.set(txtLines, { opacity: 0, y: 30 })

            if (ligne) txt.appendChild(ligne)
        }
        if (ligne) gsap.set(ligne, { scaleY: 0, transformOrigin: "top center" })
        if (para) gsap.set(para, { opacity: 0 })

        // Timeline d'apparition — déclenchée à l'entrée dans la vue
        let tl = gsap.timeline({
            defaults: { ease: "power3.out" },
            scrollTrigger: {
                trigger: bloc,
                start: "top 80%"
            }
        })

        // 1 — Ligne : tracé de haut en bas (0% → 100%)
        if (ligne) {
            tl.to(ligne, { scaleY: 1, duration: 0.8, ease: "power2.out" }, 0)
        }

        // 2 — Texte gauche : apparition ligne par ligne
        if (txtLines) {
            tl.to(txtLines, {
                opacity: 1,
                y: 0,
                duration: 0.7,
                stagger: 0.12
            }, 0.2)
        }

        // 3 — Chapeau droite : fade in
        if (para) {
            tl.to(para, { opacity: 1, duration: 2.5 }, 0.7)
        }

    })

});
